const isDebugMode = () => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('debug') === 'true'
}

const debugLog = (...args) => {
  if (isDebugMode()) {
    console.log(...args)
  }
}

export { debugLog }
